import '../../Assets/Styles/home.css';
import '../../Assets/Styles/partner.css';
import React from "react";
import { useMediaQuery } from 'react-responsive'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {useNavigate} from 'react-router-dom';

import { Helmet } from 'react-helmet';

import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button'; 

import jwtDecode from 'jwt-decode';

// Load Actions
import * as AppActions from '../../Store/Actions/App'

// Load Componentes
import HeaderView from '../../Components/Layout/Header';
import FaqView from '../../Components/Partner/Faq';

// Set assets
import backgroundPartnerHome from '../../Assets/Images/backgroundPartnerHomeResTeste.png';
import backgroundPartnerBlock1 from '../../Assets/Images/backgroundPartnerBlock1.png';

import backgroundPartnerBlock1Mobile from '../../Assets/Images/backgroundPartnerBlock1MobileAlt.png';
import backgroundPartnerHomeMobile from '../../Assets/Images/backgroundPartnerBlock1Mobile.png';

import backgroundPartnerBlockFaq from '../../Assets/Images/backgroundPartnerBlockFaq.png';
import diferencialImage from '../../Assets/Images/diferencialImage.png';
import edoLogoOnly from '../../Assets/Images/edoLogoOnly.svg'; 
import iconCardUser from '../../Assets/Images/iconCardUser.svg'; 
import iconCardGraph from '../../Assets/Images/iconCardGraph.svg'; 
import iconCardPig from '../../Assets/Images/iconCardPig.svg'; 
import iconCardBusiness from '../../Assets/Images/iconCardBusiness.svg';
import imageFallback from '../../Assets/Images/imagePlaceholder.jpg'; 


import {
	getSlugWithId,
	handleClickScroll
} from '../../Components/Utils';


const PartnerHomePage = (props) => {
	
// Set var from props
const {
	setDialog,
	setLoginStatus,
	loginStatus,
	currentCompanyStatus,
	activationStatus,
	setActivationStatus,
} = props;


// set Use of history for PUSH 
var navigate = useNavigate();
	
const isDesktopOrLaptop = useMediaQuery({
query: '(min-width: 1024px)'
})
const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1023px)' })
const isMobile = useMediaQuery({ query: '(max-width: 767px)' });
	
// Blog news 
const [noticias, setNoticias] = React.useState([]);

// Função para buscar posts
React.useEffect(() => {
	
	const buscarPosts = async () => {
		try {

			const catRes = await fetch('https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/categories?slug=midia');
			const catData = await catRes.json();
			const catId = catData[0]?.id;
  
			let url = `https://backendcms.estacaodoolho.com.br/wp-json/wp/v2/posts?_embed&per_page=4&categories_exclude=${catId}&orderby=date&order=desc`;

			const res = await fetch(url);
			const data = await res.json();
			setNoticias(data);
		} catch (err) {
			console.error('Erro ao buscar posts:', err);
		}
	};
	buscarPosts();
	window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);

// Função para lidar com o clique na postagem
const handleClick = (noticia) => {
	const url = getSlugWithId(noticia.title?.rendered, noticia.id);
	navigate(url);
};


// If not logged, show login screen
  return (
	<>
	<Helmet>
	  <title>Seja um parceiro</title>
	  <meta name="description" content="Descubra as vantagens e benefícios de ser um parceiro da Estação do Olho." />
	  <meta name="keywords" content="oftalmologia, clínica, saúde ocular, exames de vista" />
	</Helmet>	
	<div id="partnerMainSection" className="wrapper_partner__content" >

		<img src={isMobile ? backgroundPartnerHomeMobile : backgroundPartnerHome} className="wrapper_partner__content_bgPhoto   block1" />

		<HeaderView />

		<div className={isMobile ? "mobileWrapperBox wrapper_partner__content_container" : "wrapper_partner__content_container"}> 
		
			{/*<!-- Webdoor Slogan and descriptiob + CTA -->*/}
			<div className="wrapper_partner__content_container_block block1" style={{height:isMobile ? "46rem" : "28rem"}}>  

				
				<div className="wrapper_partner__content_container_webdoor">
					<div className="wrapper_partner__content_container_webdoor_title">Mais pacientes, menos burocracia</div>	
					<div className="wrapper_partner__content_container_webdoor_description">A Estação do Olho conecta você a pacientes qualificados, sem custos fixos ou dependência de convênios. Amplie sua agenda com eficiência e previsibilidade!</div>
					<div className="wrapper_partner__content_container_webdoor_cta">
						<Button label="Cadastre-se agora" className="ctaWebdoor p-button-raised" onClick={() => navigate("/parceiros/cadastro")} />
					</div>
				</div>

			</div>			
			
			{/*<!-- 3 cards -->*/}
			<div className="wrapper_partner__content_container_block">  

				<div className="wrapper_partner__content_container_cards" style={{marginTop:"1rem"}}>

					<div className="card cardScreening">
						<div className="cardScreening__icon">1</div>
						<div className="cardScreening__title">Paciente chega até aqui</div>
						<div className="cardScreening__description">Fazemos campanhas em mídias convencionais e sociais para atrair pacientes interessados em cuidados oftalmológicos.</div>
					</div>

					<div className="card cardScreening">
						<div className="cardScreening__icon">2</div>
						<div className="cardScreening__title">Conexão com médicos parceiros</div>
						<div className="cardScreening__description">A plataforma indica médicos e clínicas para consultas, exames ou cirurgias.</div>
					</div>


					<div className="card cardScreening">
						<div className="cardScreening__icon">3</div>
						<div className="cardScreening__title">Atendimento sem custo fixo</div>
						<div className="cardScreening__description">Você recebe pacientes qualificados e paga apenas pelos direcionamentos.</div>
					</div>


				</div>				

			</div>	

			{/*<!-- Highlight and 4 cards -->*/}
			<div className="wrapper_partner__content_container_block">  

				<div className="wrapper_partner__content_container_highlight">

						<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
						<div className="wrapper_partner__content_container_highlight_title">Desafios para clínicas oftalmologistas</div>
						<div className="wrapper_partner__content_container_highlight_description">Médicos enfrentam desafios constantes na captação de pacientes. Marketing digital, custos operacionais e a dependência de convênios muitas vezes limitam o crescimento. Como superar essas barreiras?</div>

				</div>

				<div className="wrapper_partner__content_container_cards" style={{flexDirection:isMobile ? "column" : "",flexWrap:"nowrap",marginTop:"3.5rem"}}>

					<div className="card cardPartner cardScreening">
						<div className="cardScreening__icon"><img src={iconCardUser} style={{marginLeft:"0.2rem",width:"1.68rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Captação de pacientes</div>
						<div className="cardScreening__description">Difícil alcançar pacientes sem alto investimento em marketing.</div>
					</div>


					<div className="card cardPartner cardScreening">
						<div className="cardScreening__icon"><img src={iconCardGraph} style={{marginLeft:"0.2rem",width:"1.68rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Concorrência Crescente</div>
						<div className="cardScreening__description">Profissionais precisam se destacar para atrair novos atendimentos.</div>
					</div>


					<div className="card cardPartner cardScreening">
						<div className="cardScreening__icon"><img src={iconCardPig} style={{marginLeft:"0.2rem",width:"1.68rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Custos com aquisição de pacientes</div>
						<div className="cardScreening__description">Estratégias tradicionais exigem grandes investimentos com retorno incerto.</div>
					</div>


					<div className="card cardPartner cardScreening">
						<div className="cardScreening__icon"><img src={iconCardBusiness} style={{marginLeft:"0.2rem",width:"1.68rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div>
						<div className="cardScreening__title">Burocracia dos convênios</div>
						<div className="cardScreening__description">Longos prazos para recebimento e glosas prejudicam a previsibilidade financeira.</div>
					</div>


				</div>				

			</div>	

			{/*<!-- CTA BOX  -->*/}
			<div className="wrapper_partner__content_container_block" style={{marginTop:"1.5rem"}}>  
				
				<div className="wrapper_partner__content_container_ctabox">

					<div className="wrapper_partner__content_container_ctabox_left"> 
						<div className="title">Junte-se à Estação do Olho e expanda seu atendimento!</div>
					</div>

					<div className="wrapper_partner__content_container_ctabox_right"> 
						<div className="text">
							Com um modelo inteligente de captação, a Estação do Olho garante que você receba apenas pacientes reais, interessados e prontos para agendar.Você cuida da sua prática clínica, enquanto nós cuidamos da sua agenda!
						</div>						
						<div className="cta">
							<Button label="Seja nosso parceiro" rounded className="pT10 mL0 headerButtonRight filled" style={{marginTop:"0.5rem"}}  onClick={() => navigate("/parceiros/cadastro")}  />
						</div>												
					</div>					
	
				</div>
			</div>


			{/*<!-- Highlight and 6 cards -->*/}
			<div className="wrapper_partner__content_container_block">  

				<div className="wrapper_partner__content_container_highlight" style={{marginTop:"5rem"}}>

						<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
						<div className="wrapper_partner__content_container_highlight_title">Vantagens e benefícios</div>
						<div className="wrapper_partner__content_container_highlight_description">A Estação do Olho é mais do que um projeto – é uma comunidade de profissionais dedicados ao bem-estar dos nossos pacientes. Associe-se hoje e seja um líder em oftalmologia social, transformando vidas e ampliando seu alcance profissional.</div>

						<div className="wrapper_partner__content_container_highlight_cta"><Button label="Seja nosso parceiro" rounded className="pT10 headerButtonRight filled" style={{marginTop:"0.5rem"}}  onClick={() => navigate("/parceiros/cadastro")} /></div>

				</div>

				<div className="wrapper_partner__content_container_cards" style={{marginTop:"3.5rem",flexWrap:"wrap"}}>

					<div className="card cardScreening purple">
						<div className="cardScreening__icon purple">01</div>
						<div className="cardScreening__title">Mais pacientes sem esforço</div>
						<div className="cardScreening__description">Direcionamento de clientes qualificados e prontos para consulta.</div>
					</div>

					<div className="card cardScreening purple">
						<div className="cardScreening__icon purple">02</div>
						<div className="cardScreening__title">Sem mensalidade ou custos fixos</div>
						<div className="cardScreening__description">Pague apenas pelos direcionamentos efetivamente recebidos.</div>
					</div>

					<div className="card cardScreening purple">
						<div className="cardScreening__icon purple">03</div>
						<div className="cardScreening__title">Expansão do público</div>
						<div className="cardScreening__description">Alcance pacientes das classes C e D que precisam de atendimento.</div>
					</div>

					<div className="card cardScreening purple">
						<div className="cardScreening__icon purple">04</div>
						<div className="cardScreening__title">Tecnologia a favor do seu consultório</div>
						<div className="cardScreening__description">Relatórios detalhados e triagem oftalmológica para otimizar seu atendimento.</div>
					</div>

					<div className="card cardScreening purple">
						<div className="cardScreening__icon purple">05</div>
						<div className="cardScreening__title">Independência de convênios</div>
						<div className="cardScreening__description">Pagamento direto pelo paciente, sem glosas ou burocracias.</div>
					</div>

					<div className="card cardScreening purple">
						<div className="cardScreening__icon purple">06</div>
						<div className="cardScreening__title">Destaque e credibilidade</div>
						<div className="cardScreening__description">Participe de um projeto inovador e socialmente relevante.</div>
					</div>

				</div>				

			</div>				

		</div>

		{/*<!-- Diferencial FULL Box -->*/}
		<div className="wrapper_partner__content_full_container" style={{marginTop:"6.24rem",mingHeight:"45rem",overflow:"hidden"}}> 
			<img src={isMobile ? backgroundPartnerBlock1Mobile : backgroundPartnerBlock1} className="wrapper_partner__content_bgPhoto block3" style={{minHeight:"608px"}} />

			{/*<!-- CTA BOX  -->*/}
			<div className="wrapper_partner__content_container_block flex-row justify-center align-items-end" style={{flex:1}}>  
				
				<div className="wrapper_partner__content_container_diferencialbox" style={{flexDirection:isMobile ? "column-reverse" : "", gap:isMobile ? "1rem" : ""}}>

					<div className="wrapper_partner__content_container_diferencialbox_left"> 
						<div className="image"><img src={diferencialImage} /></div>
					</div>

					<div className="wrapper_partner__content_container_diferencialbox_right" style={{paddingLeft:isMobile ? "1rem" : "",paddingRight:isMobile ? "1rem" : ""}}> 
						<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>						
						<div className="title">
							Receba quantos pacientes você desejar.
						</div>						
						<div className="text">
							Com a nossa plataforma, a triagem dos pacientes será feita de forma eficiente e prática. <br /><br />

							Ao se cadastrar, você poderá escolher a quantidade de leads que deseja receber, de acordo com suas necessidades. Assim, você recebe apenas os contatos que são relevantes para o seu negócio, otimizando seu tempo e garantindo mais agilidade no seu processo de atendimento.
						</div>						
						<div className="cta">
							<Button label="Seja nosso parceiro" rounded className="pT10 mL0 headerButtonRight filled" style={{marginTop:"0.5rem"}}  onClick={() => navigate("/parceiros/cadastro")} />
						</div>												
					</div>					
	
				</div>
			</div>

		</div>

		{/*<!-- Price BOX -->*/}
		<div className="wrapper_partner__content_container" style={{paddingTop:"1.5rem"}}> 
		
			{/*<!-- Highlight and 4 cards -->*/}
			<div className="wrapper_partner__content_container_block">  

				<div className="wrapper_partner__content_container_highlight" style={{marginTop:isMobile ? "1rem" : "5rem"}}>

						<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
						<div className="wrapper_partner__content_container_highlight_title">Faça parte agora!</div>
						<div className="wrapper_partner__content_container_highlight_description">Ganhe mais pacientes sem precisar investir em divulgação. Nossa plataforma conecta você a pacientes reais, com um modelo transparente e sem custos fixos.</div>

				</div>

				<div className="wrapper_partner__content_container_price" style={{flexWrap:"nowrap",marginTop:"3.5rem"}}>

					<div className="cardPrice">
						
						<div className="cardPrice_call">PAGUE APENAS PELOS DIRECIONAMENTOS RECEBIDOS</div>

						<div className="cardPrice_left">

							<div className="cardPrice__tagline">Investimento</div>
							<div className="cardPrice__title">
								{/*<span>À partir de</span>*/}						
								<span>Apenas</span>						
								<span className="featured">R$ 30,00 por</span>
								<span>paciente direcionado</span>
							</div>
							<div className="cardPrice__disclaimer">Mínimo de 10 direcionamentos de consulta oftalmológicas</div>							

						</div>

						<div className="cardPrice_right">

							<div className="cardPrice__subtitle">Detalhamento</div>
							<div className="cardPrice__features">
								<ul>
									<li><div className="cardPrice__icon"><img src={iconCardUser} style={{width:"1.25rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div><div style={{textAlign:"left"}}>Pagamento somente por pacientes entregues</div></li>
									<li><div className="cardPrice__icon"><img src={iconCardUser} style={{width:"1.25rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div><div  style={{textAlign:"left"}}>Sem custos fixos ou assinaturas</div></li>
									<li><div className="cardPrice__icon"><img src={iconCardUser} style={{width:"1.25rem",height:"auto",aspectRatio:"1/1"}} className="noSelect" /></div><div style={{textAlign:"left"}}>Tabela de preços de consultas, exames e cirurgia definida pela Estação do Olho</div></li>
								</ul>
							</div>							
							<div className="cardPrice__cta"><Button label="Quero ser parceiro" rounded className="pT10 mL0 headerButtonRight filled" style={{marginTop:"0.5rem"}}  onClick={() => navigate("/parceiros/cadastro")} /></div>							

						</div>						

					</div>

				</div>				

			</div>	
		
		</div>

		{/*<!-- FAQ FULL box -->*/}
		<div className="wrapper_partner__content_full_container" style={{background: 'linear-gradient(180deg,rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 1) 15%, rgba(77, 71, 146, 1) 15%, rgba(77, 71, 146, 1) 100%) no-repeat',marginTop:isMobile ? "3rem" : "10rem",mingHeight:"45rem",overflow:"hidden"}}> 
			<img src={backgroundPartnerBlockFaq} className="wrapper_partner__content_bgPhoto block4" />

			{/*<!-- CTA BOX  -->*/}
			<div className="wrapper_partner__content_container_block flex-row justify-center align-items-end" style={{flex:1}}>  
				
				<div className="wrapper_partner__content_container_diferencialbox">

					<FaqView />	
	
				</div>

			</div>

		</div>

		{/*<!-- Blog Highlights BOX -->*/}
		<div className="wrapper_partner__content_container"> 
		
			{/*<!-- Blog Highlight with 4 cards -->*/}
			<div className="wrapper_partner__content_container_block">  

				<div className="wrapper_partner__content_container_highlight" style={{paddingLeft:isMobile ? "1rem" : "",paddingRight:isMobile ? "1rem" : "",marginTop:isMobile ? "0rem" : "6.5rem"}}>

						<div><img src={edoLogoOnly} style={{width:"2.5rem",height:"auto",aspectRatio:"40/27.20"}} className="noSelect" /></div>
						<div className="wrapper_partner__content_container_highlight_title">Desafios para clínicas oftalmologistas</div>
						<div className="wrapper_partner__content_container_highlight_description">Médicos enfrentam desafios constantes na captação de pacientes. Marketing digital, custos operacionais e a dependência de convênios muitas vezes limitam o crescimento. Como superar essas barreiras?</div>

				</div>

				<div className="wrapper_partner__content_container_cards wrapper_home__content_container_cardsBlog" style={{flexWrap:"nowrap",marginTop:"3.5rem"}}>

					{noticias.map(post => {
						
						const midia = post._embedded?.['wp:featuredmedia']?.[0];
						const image = midia?.media_details?.sizes?.medium?.source_url
						|| midia?.media_details?.sizes?.thumbnail?.source_url
						|| midia?.source_url;	

						//const category = post._embedded?.['wp:term']?.[0]?.[0]?.name || 'Sem categoria';

						const categories = post._embedded?.['wp:term']?.[0] || [];

						// Função para remover acentos
						const sanitize = (str) => {
						  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, "").replace(/\s+/g, '');
						};						

						return (
							<div key={post.id} className="card cardBlog applyPointer" onClick={() => handleClick(post)}>
							<div className="cardBlog__image">
								<img src={image || imageFallback} className="noSelect" alt={post.title.rendered}   onError={(e) => { 
									e.target.onerror = null; // evita loop infinito
									e.target.src = imageFallback;
								}} />
							</div>
							<div className="cardBlog__category" style={{gap:"0.5rem"}}>

								{categories.slice(0, 3).map((cat, idx) => (
									<span key={idx} className={sanitize(cat.name)}>{cat.name}</span>
								))}	

								{categories.length == 0 && (
									<span className="semCategoria">Sem categoria</span>
								)}

							</div>
							<div className="cardBlog__title" dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
							<div className="cardBlog__description" dangerouslySetInnerHTML={{ __html: post.excerpt.rendered }} />
							</div>
						);
					})}	

				</div>		

				<div className="wrapper_partner__content_container_cta" style={{marginTop:"2.5rem",marginBottom:"7.31rem"}}><Button label="Leia mais no blog" rounded className="pT10 headerButtonRight filled" style={{marginTop:"0.5rem"}} onClick={()=>navigate("/noticias")}  /></div>

			</div>	
		
		</div>


    </div>
	</>
  );
    
}

const mapStateToProps = store => ({
  dialog:store.appReducer.dialog,
  loginStatus:store.appReducer.loginStatus,
  currentCompanyStatus:store.appReducer.currentCompanyStatus,
  activationStatus:store.appReducer.activationStatus
 });
const mapDispatchToProps = dispatch => bindActionCreators({ ...AppActions }, dispatch);

export default connect(
		mapStateToProps,
		mapDispatchToProps
	)(PartnerHomePage);	


